import React from 'react'

const Footer = () => {
  return (
    <div className='footer-row'>
          <span>&copy; 2022. All Rights Reserved. Powered by MD.Masum Haque. </span>
    </div>
  )
}

export default Footer